import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "M16 4 4.333 16M4 4l11.667 12" }));
export default SvgClose;
